import { timesheetKeys } from "components/timesheet/queries";
import React from "react";
import { startOfMonth, formatISO, subDays } from "date-fns";
import {
  fetchThisMonthAvailableHours,
  fetchTimesheet,
  fetchDraftTimesheet,
} from "components/timesheet/dashboard/api";
import { getStatSummary } from "components/timesheet/dashboard/performance/transformer";
import { useQuery } from "@tanstack/react-query";
import { AnalyticsStatsCard } from "components/analytics/display-card";
import AnalyticsStatsLoader from "components/timesheet/dashboard/performance/loader";
import { formatHoursToTime } from "utils/timesheet";
import { AnalyticsStatsCardWithSeparator } from "components/analytics/display-card-with-separator";
import { DisplayPercentage } from "components/display/percentage";

const TimesheetPerformanceStat = () => {
  const startDate = formatISO(startOfMonth(subDays(new Date(), 1)), {
    representation: "date",
  });

  const { data: draftData, isLoading: loadingDraft } = useQuery({
    queryKey: timesheetKeys.thisMonthDraftTimesheet(startDate),
    queryFn: () => fetchDraftTimesheet({ startDate }),
  });

  const { data: timesheetData, isLoading: loadingTimesheet } = useQuery({
    queryKey: timesheetKeys.thisMonthTimesheet(startDate),
    queryFn: () => fetchTimesheet({ startDate }),
  });

  const { data: capacityData, isLoading: loadingCapacity } = useQuery({
    queryKey: timesheetKeys.thisMonthPayrollHours(startDate),
    queryFn: () => fetchThisMonthAvailableHours({ startDate }),
  });

  const isLoading = loadingTimesheet || loadingCapacity;

  if (isLoading) return <AnalyticsStatsLoader />;

  const stats = getStatSummary(timesheetData, capacityData, draftData);

  return (
    <>
      <AnalyticsStatsCardWithSeparator
        label="Available"
        value={formatHoursToTime(stats.available)}
      />
      <AnalyticsStatsCardWithSeparator
        label="Logged"
        value={formatHoursToTime(stats.logged)}
      />
      <AnalyticsStatsCardWithSeparator
        label="Draft"
        value={formatHoursToTime(stats.draft)}
      />
      <AnalyticsStatsCardWithSeparator
        label="Unreviewed"
        value={formatHoursToTime(stats.unreviewed.value)}
        change={stats.unreviewed.percent}
      />
      <AnalyticsStatsCardWithSeparator
        label="Unapproved"
        value={formatHoursToTime(stats.unapproved.value)}
        change={stats.unapproved.percent}
      />
      <AnalyticsStatsCard
        label="Utilization"
        // value={`${stats.utilization}%`}
        value={
          <DisplayPercentage
            value={stats.utilization}
            withSuffix={true}
            precision={0}
          />
        }
      />
    </>
  );
};

export default TimesheetPerformanceStat;
